export default __webpack_public_path__ + "static/RecueilAvis2-9b06c4495c8bd585ba17c2244ad5b6d6.png";